import { render } from "./PracticeRoomView.vue?vue&type=template&id=aade1054&scoped=true"
import script from "./PracticeRoomView.vue?vue&type=script&lang=js"
export * from "./PracticeRoomView.vue?vue&type=script&lang=js"

import "./PracticeRoomView.vue?vue&type=style&index=0&id=aade1054&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aade1054"]])

export default __exports__